<template>
  <a-select
    v-model:value="model"
    :allow-clear="allowClear"
    :disabled="disabled"
    :id="id"
    :options="options"
    :placeholder="placeholder"
    :show-search="showSearch"
    :filter-option="false"
    :loading="loading"
    :not-found-content="notFoundContent"
    @search="handleSearch"
    @blur="handleBlur"
  >
    <template #notFoundContent>
      <a-spin size="small" />
    </template>
  </a-select>
</template>

<script setup>
  /**
   * Компонент-фасад для компонента <a-select/> из библиотеки ant-design-vue.
   * Его нужно использовать в коде компонентов вместо <a-select/>.
   *
   * Пример использования:
   * <select-facade
   *   v-model="model.userId"
   *   :options="users"
   *   placeholder="Выберите сотрудника"
   * />
   */

  import { defineModel } from 'vue';

  const emit = defineEmits(['search', 'blur']);
  const model = defineModel();

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
    options: {
      default: [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    notFoundContent: {
      type: Object,
      default: undefined,
    },
  });

  const handleSearch = (value) => {
    emit('search', value);
  };

  const handleBlur = (value) => {
    emit('blur', value);
  };
</script>

<style lang="scss" scoped></style>
